/****
 * 合并权限
 * ****/
export function setPermission(permissions) {
  // console.log(permissions)
  let permissionsList = []
  if (permissions.length > 1) {
    //多个权限列表需要合并checked值
    permissionsList = permissions[0].data
    for (var i = 1; i < permissions.length; i++) {
      permissions[i].data.forEach((element, index) => {
        permissionsList[index].checked = permissionsList[index].checked || element.checked
      })
    }
    // console.log(permissionsList)
  } else {
    permissionsList = permissions[0].data
  }
  return permissionsList
}
/****
 * 校验权限
 * ****/
export function checkPermission(moduleName) {
  // return true
  if (moduleName != null && moduleName != '') {
    const permissions = JSON.parse(sessionStorage.getItem('permissionsList'))
    var hasPermission = permissions.filter((item) => {
      return item.code == moduleName
    })
    if (hasPermission.length == 0) {
      return false
    }
    return hasPermission[0].checked
  } else {
    return true
  }
}
export function getUserLevel() {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  // 判断是否有权限信息
  if (!userInfo.roleName) return
  if (userInfo.roleName.includes('区系统管理员')) {
    return 'district'
  } else if (userInfo.roleName.includes('社区（村）系统管理员')) {
    return 'community'
  } else {
    return 'town'
  }
}




// WEBPACK FOOTER //
// ./src/common/utils/permission.js